import React, { FC, useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { FormField, Label, Combobox, FormHelp } from '@zillow/constellation';
import { useListSettlementAgentsQuery } from 'API/settlement-agents/SettlementAgentsAPI';

const useGetSettlementAgents = () => {
  const { data: settlementAgents = [] } = useListSettlementAgentsQuery();

  return useMemo(
    () =>
      settlementAgents.map(({ id, name }) => ({
        label: name,
        value: id,
        id,
      })),
    [settlementAgents]
  );
};

export const SettlementAgentsFilter: FC = () => {
  const [field, meta, helpers] = useField<string>({ name: 'settlementAgentId' });
  const settlementAgentsOptions = useGetSettlementAgents();

  const onChange = useCallback(
    (nextValue: any, constellationComboboxMeta: any) => {
      helpers.setValue(constellationComboboxMeta.option.value);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Settlement Agent</Label>}
      control={
        <Combobox
          value={field.value}
          options={settlementAgentsOptions}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
